import Faculty from "../Components/Members/Faculty";
import LongVisitors from "../Components/Members/LongVisitors";
import Postdoc from "../Components/Members/Postdoc";
import Graduates from "../Components/Members/Graduates";
import Undergrads from "../Components/Members/Undergrads";
import ShortVisitors from "../Components/Members/ShortVisitors";
import Alumni from "../Components/Members/Alumni";
import Staff from "../Components/Members/Staff";

const Members = () => {

    // const baseUrl = "https://web.phys.ntu.edu.tw/string2022/files";
    // const imgBaseUrl = "https://web.phys.ntu.edu.tw/string2022/pic/";
    // const defaultImg="https://web.phys.ntu.edu.tw/string/pic/string2.jpg";

    const baseUrl = "https://web.phys.ntu.edu.tw/string/files";
    const imgBaseUrl = "https://web.phys.ntu.edu.tw/string/pic/";
    const defaultImg="https://web.phys.ntu.edu.tw/string/pic/string2.jpg";


    // const baseUrl = "./public/files/";
    // const imgBaseUrl = "./public/pic/";

    const toDownload = true;

    return(
        <>
            <div className="row cards">
                <Faculty url={baseUrl+"/faculty_list.csv"} toDownload={toDownload} baseUrl={imgBaseUrl} defaultImg={defaultImg} />
            </div>
            <div className="row cards">
                <LongVisitors url={baseUrl+"/long_term_visitors_list.csv"} toDownload={toDownload} baseUrl={imgBaseUrl} defaultImg={defaultImg} />
            </div>
            <div className="row cards">
                <Postdoc url={baseUrl+"/postdoc_list.csv"} toDownload={toDownload} baseUrl={imgBaseUrl} defaultImg={defaultImg} />
            </div>
            <div className="row cards">
                <Graduates url={baseUrl+"/graduates_list.csv"} toDownload={toDownload} baseUrl={imgBaseUrl} defaultImg={defaultImg} />
            </div>
            <div className="row cards">
                <Undergrads url={baseUrl+"/undergrads_list.csv"} toDownload={toDownload} />
            </div>
            <div className="row cards"> 
                <ShortVisitors url={baseUrl+"/short_term_visitors_list.csv"} toDownload={toDownload} />
            </div>
            <div className="row cards"> 
                <Alumni url={baseUrl+"/alumni_list.csv"} toDownload={toDownload} />
            </div>
            <div className="row cards">
                <Staff url={baseUrl+"/staff_list.csv"} toDownload={toDownload} baseUrl={imgBaseUrl} defaultImg={defaultImg} />
            </div>
        </>    
    )
}

export default Members;